/**
 * The wall clock, as an external store for `useSyncExternalStore`.
 *
 * `getSnapshot` must be stable between store changes: React re-reads it on
 * every commit (`checkIfSnapshotChanged`) and re-renders when the value moved,
 * so a snapshot that differs on *every* call is not a warning but a
 * "Maximum update depth exceeded" crash. Reading the clock in `getSnapshot` is
 * safe here for one reason: `Dates.now()` is `moment().unix()`, whole seconds,
 * so a formatted snapshot can only change once per tick — at worst a second
 * boundary falls between the render and the commit re-read, which costs one
 * extra render and then converges. Anything that gives these hooks a
 * sub-second input breaks that, so `useCurrentTime`'s suite pins the
 * truncation.
 */
export const subscribeToSeconds = (onClockTick: () => void) => {
  const interval = setInterval(onClockTick, 1000);
  return () => clearInterval(interval);
};

/**
 * For a label the clock cannot change — an absent timestamp formats to a
 * constant, so it subscribes to nothing rather than running an interval whose
 * every tick is a no-op.
 */
export const subscribeToNothing = () => () => {};
